import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import BareBonesNavbar from '../BareBonesNavbar'
import Container from '../Container'
import Body from '../Body'

import styles from './styles'

const SceneLayout = ({ children, showNav = true }) => (
  <Fragment>
    <If condition={showNav}>
      <BareBonesNavbar />
    </If>
    <Body>
      <Container className={styles.container}>{children}</Container>
    </Body>
  </Fragment>
)

SceneLayout.propTypes = {
  showNav: PropTypes.bool,
}

export default SceneLayout
